module.exports = __webpack_public_path__ + "static/media/fin_dwn4.3059a8cd.png";